export default __webpack_public_path__ + "static/media/pension-plan-benefit.4ed7cc17.png";